<!-- สต็อคออนไลน์ -->
<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
<section class="content" id="stockonline">
  <div class="col-lg-12">
    <mat-card class="example-card">
      <mat-form-field appearance="standard">
        <mat-label>ค้นหาชื่อสต็อค หรือ รายการ</mat-label>
        <input matInput (keyup)="applyFilter2($event)" placeholder="รายการที่ต้องการหา" #input>
        </mat-form-field>
        
        <table mat-table [dataSource]="dataSource2" matSort>
        
        <ng-container matColumnDef="whsName" >
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 250px;" id="KanitTH"> สต็อค </th>
          <td mat-cell *matCellDef="let element" id="Kanit"> {{element.whsName}} </td>
        </ng-container>
        
        <ng-container matColumnDef="whscode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 700px;" id="KanitTH"> รายการ </th>
          <td mat-cell *matCellDef="let element" id="Kanit"> {{element.itemcode}} | {{element.itemname}}</td>
        </ng-container>
        
        <tr mat-header-row  *matHeaderRowDef="displayedColumns2 ; sticky: true;" ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
        
        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">ไม่มีข้อมูลตรงกัน "{{input.value}}"</td>
        </tr>
        </table>
        <mat-paginator  [pageSizeOptions]="[1, 5, 10, 25]" showFirstLastButtons aria-label="Select page of periodic elements"  
                         
        ></mat-paginator>
    </mat-card>
  </div>
  
</section>  
<!-- สต็อคออนไลน์ -->


</div>
<app-footer></app-footer>